import { t } from "i18next";

import Button from "~/components/buttons/Button/Button";
import Hint from "~/components/Hint";
import SidebarContent from "~/components/Sidebar/components/SidebarContent";
import SidebarFooter from "~/components/Sidebar/components/SidebarFooter";
import SidebarHeader from "~/components/Sidebar/components/SidebarHeader";
import SidebarHeaderHeadline from "~/components/Sidebar/components/SidebarHeaderHeadline";
import { normalizeTKey } from "~/types/typeHelpers.ts";

type Props = {
	onClose: () => void
};

const UpdateOrderBillingSettingsOrderCombinedWarning = ({ onClose }: Props) => {
	return <div
		className="flex min-h-full w-full flex-col justify-start"
	>
		<SidebarHeader>
			<SidebarHeaderHeadline>Abrechnungsdetails bearbeiten</SidebarHeaderHeadline>
		</SidebarHeader>
		<SidebarContent>
			<Hint theme="info">
				Die Bestellungen dieses Projekts werden per Sammelrechnung abgerechnet. Daher können die
				Abrechnungsdetails der Bestellung nicht separat geändert werden.
			</Hint>
		</SidebarContent>
		<SidebarFooter>
			<Button theme="none"
					onClick={onClose}>
				{t(normalizeTKey("form:buttonTexts.cancel"))}
			</Button>
		</SidebarFooter>
	</div>;
};

export default UpdateOrderBillingSettingsOrderCombinedWarning;